
export default {
    organization: [
        {
            title: '轻松解决招生难题',
            subTitle: '教培机构专属招生CRM，线下体验课、线上微分销裂变，打造线上线下融合的招生营销方案，轻松解决招生难题',
            img: require('@/assets/site/programme_educloud/icon_e1.png')
        }, {
            title: '高效解决排课难题',
            subTitle: '智能排课冲突检测，避免学员、课室、讲师之间的时间及资源冲突题，高效生成课表，提高排课准确性，解决人工排课难题',
            img: require('@/assets/site/programme_educloud/icon_e3.png')
        }, {
            title: '精准解决学员复购难题',
            subTitle: '重要通知实时推送、教学动态随时了解、丰富的在线自助服务等，从细节入手， 提高学员及家长满意度，解决复购难题',
            img: require('@/assets/site/programme_educloud/icon_e2.png')
        }, {
            title: '根本上解决管理难题',
            subTitle: '教培机构专属ERP，规范教务管理，业务数据可视化，随时掌握状态，提效率降成本，解决管理难题',
            img: require('@/assets/site/programme_educloud/icon_e4.png')
        }
    ],
    knowladge: [
        {
            title: '丰富知识变现内容形式',
            subTitle: '支持图文、直播、音频、视频等形态，通过最合适的形态展示知识，结合专栏、训练营组织形式，有效促进快速变现',
            img: require('@/assets/site/programme_educloud/icon_k1.png')
        }, {
            title: '通用营销工具',
            subTitle: '优惠券、限时折扣、秒杀、礼包等常用营销工具，结合微信生态分享优惠券、知识商品、裂变海报，有效拉新会员',
            img: require('@/assets/site/programme_educloud/icon_k2.png')
        }, {
            title: '多种社群式助学工具',
            subTitle: '打卡、表单、考试、证书等工具与课程相结合，实时在线跟进学员学习情况，打造陪伴式学习效果，提升完课率',
            img: require('@/assets/site/programme_educloud/icon_k4.png')
        }, {
            title: '多级会员运营管理',
            subTitle: '多级会员管理体系，有效运营用户，提高学员留存',
            img: require('@/assets/site/programme_educloud/icon_k3.png')
        }
    ],
    enterprese: [
        {
            title: '专属培训管理系统',
            subTitle: '连接企业微信/钉钉等办公场景，极大简化管理工作，提升培训管理效率',
            img: require('@/assets/site/programme_educloud/icon_ep1.png')
        }, {
            title: '企业培训体系',
            subTitle: '基于岗位定制培训课程、培训计划，为员工规划成长路线，轻松实现企业知识沉淀传承',
            img: require('@/assets/site/programme_educloud/icon_ep2.png')
        }, {
            title: '集团企业学习',
            subTitle: '支持公众号、小程序、H5等多种终端，轻松实现直播培训、移动学习，把培训融入到员工的日常工作生活中，随时随地开启企业培训',
            img: require('@/assets/site/programme_educloud/icon_ep5.png')
        }, {
            title: '安全稳定可靠',
            subTitle: '多地容灾，智能调度，可用性高；防盗链、防录屏，保证数据安全；严格的权限控制保障企业培训的私密性',
            img: require('@/assets/site/programme_educloud/icon_ep3.png')
        }
    ],
    characteristic: [
        {
            title: '主流课程内容形式',
            subTitle: '支持图文、音频、视频、电子书、直播共5种主流的内容形式，通过多种内容形式组合，定制计划，并结合督学工具，打造陪伴式学习服务，提升学习效果及课程完课率',
            img: require('@/assets/site/programme_educloud/feature_1.png')
        }, {
            title: '多种督学工具',
            subTitle: '打造“学、练、考”学习闭环',
            img: require('@/assets/site/programme_educloud/feature_2.png')
        }, {
            title: '互动直播系统',
            subTitle: '上手快、零延时、拿来即用',
            desc: [
                '音频、视频、PPT、白板组合组合，满足各种场景需求',
                '简单易用直播助手，上手快',
                '跨平台适配，支持多种终端操作',
                '高并发直播服务，零延时互动体验'
            ],
            img: require('@/assets/site/programme_educloud/feature_4.png')
        }, {
            title: '排课调课系统',
            subTitle: '智能冲突检测，实时课程统计',
            desc: [
                '打通线上线下课程安排',
                '智能排课冲突检测',
                '学员一键请假、签到',
                '补课调课轻松实现',
                '老师上课、学员销课汇总'
            ],
            img: require('@/assets/site/programme_educloud/feature_5.png')
        }
    ],
    why: [
        {
            title: '一站式在线教育解决方案',
            subTitle: '一站式在线教育解决方案，满足各种教育场景需求',
            img: require('@/assets/site/programme_educloud/ts_fast.jpg')
        }, {
            title: 'SaaS服务，节省成本',
            subTitle: 'SaaS服务为你节省99%的研发成本',
            img: require('@/assets/site/programme_educloud/SaaS.jpg')
        }, {
            title: '专业团队，更懂教育',
            subTitle: '专业团队，8年线上线下教育实践，更懂教育',
            img: require('@/assets/site/programme_educloud/ts_professional.jpg')
        }, {
            title: '安全、可靠、可扩展',
            subTitle: '基础设施基于阿里云，安全可靠，可动态扩展',
            img: require('@/assets/site/programme_educloud/ts_safe.jpg')
        }
    ],
    service: [
        {
            title: '数据安全',
            subTitle: '防盗链、防录屏，保证数据安全',
            img: require('@/assets/site/programme_educloud/icon_red3.png')
        }, {
            title: '稳定可靠',
            subTitle: '基于主流云供应商，稳定、可靠',
            img: require('@/assets/site/programme_educloud/icon_red4.png')
        }, {
            title: '持续升级',
            subTitle: '每周升级，做在线教育全属性功能',
            img: require('@/assets/site/programme_educloud/icon_red1.png')
        }, {
            title: '灵活部署',
            subTitle: '支持试用SaaS服务或私有部署',
            img: require('@/assets/site/programme_educloud/icon_red2.png')
        }
    ],
    introduction: [
        {
            title: '课程管理',
            desc: ['直播 | 视频 | 音频 | 图文 | 电子书', '公开课 | 训练营 | 多学习模式'],
            img: require('@/assets/site/programme_educloud/icon_f1.png')
        }, {
            title: '直播系统',
            desc: ['标准直播 | 互动直播 | 直播助手', '小班课直播 | 公开课'],
            img: require('@/assets/site/programme_educloud/icon_f2.png')
        }, {
            title: '教学服务',
            desc: ['在线打卡 | 调查问卷 | 师生互评', '在线测验 | 学习动态'],
            img: require('@/assets/site/programme_educloud/icon_f3.png')
        }, {
            title: '招生引流',
            desc: ['体验课 | 邀请码 | 推广员 | 优惠券', '销售线索 | 跟进管理 | 用户运营', '分享海报 | 付费会员 | 限时折扣'],
            img: require('@/assets/site/programme_educloud/icon_f4.png')
        }, {
            title: '教务管理',
            desc: ['排课管理 | 教师管理 | 班级管理', '上课考勤 | 补课调课 | 课时统计', '课程管理 | 学员管理 | 预约管理'],
            img: require('@/assets/site/programme_educloud/icon_f5.png')
        }, {
            title: '财务管理',
            desc: ['交易订单 | 收费管理 | 收支管理', '工资管理 | 退费统计 | 收费提醒', '佣金提现 | 佣金分析'],
            img: require('@/assets/site/programme_educloud/icon_f6.png')
        }, {
            title: '经营分析',
            desc: ['交易分析 | 用户分析 | 商品分析', '招生报表 | 课程排行 | 升班分析', '班级统计 | 校区收支 | 讲师评价'],
            img: require('@/assets/site/programme_educloud/icon_f7.png')
        }, {
            title: '其他',
            desc: ['小程序、H5、PC端支持 | 账号管理', '商城装修 | 课程分类 | 支付设置', '集团、连锁机构模式 | 功能定制'],
            img: require('@/assets/site/programme_educloud/icon_f8.png')
        }
    ]
}


// WEBPACK FOOTER //
// ./src/views/product/educloud/data.js